'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _defineProperty = require('@babel/runtime-corejs3/helpers/defineProperty');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var dataSource_interface = require('./data-source.interface.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);

var DataSourceLogic = /*#__PURE__*/function () {
  function DataSourceLogic() {
    _classCallCheck__default["default"](this, DataSourceLogic);
  }
  return _createClass__default["default"](DataSourceLogic, null, [{
    key: "createDataSource",
    value:
    /**
     * Create a data source.
     *
     * @static
     * @param {string} name
     * @param {DataSourceType} type
     * @returns {DataSource}
     * @memberof DataSourceLogic
     */
    function createDataSource(name, type) {
      if (name === undefined) {
        return {
          type: type,
          isLocal: true
        };
      }
      return {
        name: name,
        type: type,
        isLocal: true
      };
    }

    /**
     * Get data source type.
     *
     * @static
     * @param {string} type
     * @return {DataSourceType}
     * @memberof DataSourceLogic
     */
  }, {
    key: "getDataSourceType",
    value: function getDataSourceType(type) {
      switch (type) {
        case dataSource_interface.DataSourceType.File:
        case dataSource_interface.DataSourceType.S3:
        case dataSource_interface.DataSourceType.GoogleCloudStorage:
        case dataSource_interface.DataSourceType.Kafka:
        case dataSource_interface.DataSourceType.AzureBlobStorage:
          return type;
        default:
          return dataSource_interface.DataSourceType.None;
      }
    }

    /**
     * Get the type of uri for a given data source type.
     *
     * @param {string} dataSourceType
     * @returns {string}
     */
  }, {
    key: "getURIName",
    value: function getURIName(dataSourceType) {
      switch (dataSourceType) {
        case dataSource_interface.DataSourceType.S3:
          return 'S3 URI';
        case dataSource_interface.DataSourceType.GoogleCloudStorage:
          return 'gsutil URI';
        case dataSource_interface.DataSourceType.AzureBlobStorage:
          return 'Blob URL';
        default:
          // TODO: add more data source types.
          return '';
      }
    }

    /**
     * Get the uri prefix for a specific data source.
     *
     * @param {string} dataSourceType
     * @returns {string}
     */
  }, {
    key: "getURIPrefixPlaceholder",
    value: function getURIPrefixPlaceholder(dataSourceType) {
      switch (dataSourceType) {
        case dataSource_interface.DataSourceType.S3:
          return 's3://';
        case dataSource_interface.DataSourceType.GoogleCloudStorage:
          return 'gs://';
        case dataSource_interface.DataSourceType.AzureBlobStorage:
          return 'https://';
        default:
          // TODO: add more data source types.
          return '';
      }
    }

    /**
     * Get link to guide users to get uri syntax.
     *
     * @param {string} dataSourceType
     * @returns {string}
     */
  }, {
    key: "getGuideLink",
    value: function getGuideLink(dataSourceType) {
      switch (dataSourceType) {
        case dataSource_interface.DataSourceType.S3:
          return 'https://docs.aws.amazon.com/AmazonS3/latest/userguide/access-bucket-intro.html#accessing-a-bucket-using-S3-format';
        case dataSource_interface.DataSourceType.GoogleCloudStorage:
          return 'https://cloud.google.com/storage/docs/gsutil#syntax';
        case dataSource_interface.DataSourceType.AzureBlobStorage:
          return 'https://learn.microsoft.com/en-us/rest/api/storageservices/copy-blob-from-url#request';
        default:
          return '';
      }
    }

    /**
     * Check if the current data source type is a kafka based data source.
     *
     * @param {string}
     * @returns {boolean}
     */
  }, {
    key: "isRemoteDataSourceType",
    value: function isRemoteDataSourceType(dataSourceType) {
      switch (dataSourceType) {
        case dataSource_interface.DataSourceType.S3:
        case dataSource_interface.DataSourceType.GoogleCloudStorage:
        case dataSource_interface.DataSourceType.AzureBlobStorage:
          return true;
        default:
          return false;
      }
    }

    /**
     * Parse the Azure Blob Storage connection string to get account name and account key.
     *
     * @static
     * @param {string} absConnectionString
     * @returns {{accountName: string, accountKey: string}}
     * @memberof LoadingBuilderService
     */
  }, {
    key: "getABSCredentials",
    value: function getABSCredentials(inputStr) {
      var _context;
      var credentialInfo = {
        accountName: '',
        accountKey: ''
      };
      _forEachInstanceProperty__default["default"](_context = inputStr.split(';')).call(_context, function (keyValuePair) {
        var matchResult = keyValuePair.match(new RegExp('AccountName=(.*)'));
        if (matchResult) {
          credentialInfo['accountName'] = matchResult[1];
        }
        matchResult = keyValuePair.match(new RegExp('AccountKey=(.*)'));
        if (matchResult) {
          credentialInfo['accountKey'] = matchResult[1];
        }
      });
      return credentialInfo;
    }
  }]);
}();
_defineProperty__default["default"](DataSourceLogic, "format", [['none', 'text'], ['zip', 'zip'], ['gzip', 'gzip'], ['tar', 'tar']]);
_defineProperty__default["default"](DataSourceLogic, "separators", [[',', ',', ','], ['\t', '\\t', '\\t'], ['.', '.', '.'], ['|', '|', '|'], ['/', '/', '/'], [':', ':', ':'], [';', ';', ';'], [' ', "\\u0020", 'whitespace'], ["'", "'", "'"], ['\\', '\\\\', '\\'], ['"', '\\"', '"'], ['^', '^', '^'], ['?', '?', '?'], ['~', '~', '~'], ['!', '!', '!'], ['@', '@', '@'], ['#', '#', '#'], ['$', '$', '$'], ['%', '%', '%'], ['&', '&', '&'], ['*', '*', '*'], ['-', '-', '-'], ['_', '_', '_'], ['+', '+', '+'], ['=', '=', '='], ['`', '`', '`'], ['<', '<', '<'], ['>', '>', '>'], ['\n', '\\n', '\\n'], [String.fromCharCode(1), '\\1', '\\1'], [String.fromCharCode(2), '\\2', '\\2'], [String.fromCharCode(3), '\\3', '\\3'], [String.fromCharCode(4), '\\4', '\\4'], [String.fromCharCode(5), '\\5', '\\5'], [String.fromCharCode(6), '\\6', '\\6'], [String.fromCharCode(7), '\\7', '\\7']]);
_defineProperty__default["default"](DataSourceLogic, "eols", [['\n', '\\n', '\\n'], ['\t', '\\t', '\\t'], ['.', '.', '.'], ['|', '|', '|'], ['/', '/', '/'], [':', ':', ':'], [';', ';', ';'], [' ', "\\u0020", 'whitespace'], ["'", "'", "'"], ['\\', '\\\\', '\\'], ['"', '\\"', '"'], ['^', '^', '^'], ['?', '?', '?'], ['~', '~', '~'], ['!', '!', '!'], ['@', '@', '@'], ['#', '#', '#'], ['$', '$', '$'], ['%', '%', '%'], ['&', '&', '&'], ['*', '*', '*'], ['-', '-', '-'], ['_', '_', '_'], ['+', '+', '+'], ['=', '=', '='], ['`', '`', '`'], ['<', '<', '<'], ['>', '>', '>'], [',', ',', ','], [String.fromCharCode(1), '\\1', '\\1'], [String.fromCharCode(2), '\\2', '\\2'], [String.fromCharCode(3), '\\3', '\\3'], [String.fromCharCode(4), '\\4', '\\4'], [String.fromCharCode(5), '\\5', '\\5'], [String.fromCharCode(6), '\\6', '\\6'], [String.fromCharCode(7), '\\7', '\\7']]);
_defineProperty__default["default"](DataSourceLogic, "quotes", [['none', '', 'None'], ["\"", 'double', "\""], ["'", 'single', "'"]]);
_defineProperty__default["default"](DataSourceLogic, "ABSConnectionStringPattern", "^(DefaultEndpointsProtocol=(http|https);)?AccountName=[a-z0-9]{3,24};" + "AccountKey=[a-zA-Z0-9/+=]*(;EndpointSuffix=([\\w\\d]+)(\\.[\\w\\d]+)*)?$");

exports.DataSourceLogic = DataSourceLogic;
